module.exports = {"410602001":"中北街道","410602002":"中山路街道","410602003":"新华街街道","410602004":"鹤山街街道","410602005":"九矿广场街道","410602100":"鹤壁集镇","410602201":"姬家山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410602.json
// module id = 1445
// module chunks = 0